import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import { queryKeys } from "../../query-keys";

export function useOutboxEvents(params?: {
	status?: string;
	event_type?: string;
	limit?: number;
	offset?: number;
}) {
	return useQuery({
		queryKey: [...queryKeys.outbox.all, params],
		queryFn: () => adminApi.outbox.list(params),
		placeholderData: keepPreviousData,
	});
}

export function useOutboxEvent(id: string) {
	return useQuery({
		queryKey: queryKeys.outbox.detail(id),
		queryFn: () => adminApi.outbox.get(id),
		enabled: !!id,
	});
}

export function useOutboxStats() {
	return useQuery({
		queryKey: queryKeys.outbox.stats,
		queryFn: () => adminApi.outbox.stats(),
	});
}

export function useRetryOutboxEvent() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (id: string) => adminApi.outbox.retry(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.outbox.all });
			queryClient.invalidateQueries({ queryKey: queryKeys.outbox.stats });
		},
	});
}

export function useRetryAllOutboxEvents() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: () => adminApi.outbox.retryAll(),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.outbox.all });
			queryClient.invalidateQueries({ queryKey: queryKeys.outbox.stats });
		},
	});
}

export function usePurgeOutboxEvent() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (id: string) => adminApi.outbox.purge(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.outbox.all });
			queryClient.invalidateQueries({ queryKey: queryKeys.outbox.stats });
		},
	});
}
